import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { Validators, UntypedFormControl, FormGroup, UntypedFormBuilder } from '@angular/forms';
import { Store } from '@ngrx/store';

import * as forgotPasscodeSelector from '../../selectors/forgot-passcode.selectors';
import * as register from '../../actions/register.actions';
import * as logout from '../../actions/logout.actions';
import * as newUserPasscode from '../../actions/new-user-passcode.actions';
import * as newUserPasscodeSelector from '../../selectors/new-user-passcode.selectors';
import { IRegistrationLoginRequest } from '../../models/registration-login.model';
import { Observable, Subscription } from 'rxjs';
import { ErrorResponse, IGenericError } from '../../../../core/models/generic-models';
import { IForgotPasscodeRequest } from '../../models/forgot-passcode.model';
import { INewUserPasscodeRequest, INewUserPasscodeSuccess } from '../../models/new-user-passcode.model';
import { ICheckRegisterRequiredRequest } from '../../../../core/models/check-registration.model';
import { SharedService } from '../../../../shared/shared.service';

@Component({
  selector: 'app-forgot-passcode',
  templateUrl: './forgot-passcode.component.html',
  styleUrls: ['./forgot-passcode.component.css']
})
export class ForgotPasscodeComponent {
  isNewUserPasscodeLoading$: Observable<boolean>;
  newUserPasscodeResponse$: Observable<INewUserPasscodeSuccess>;
  newUserPasscodeFailure$: Observable<IGenericError<ErrorResponse>>;
  getUserData$: Observable<ICheckRegisterRequiredRequest>;
  getUserDataSubscription: Subscription = new Subscription();
  subdomain: string;

  passwordForm = this.fb.group({
    passcode: new UntypedFormControl('', [Validators.required, Validators.pattern('^[0-9]+$'), Validators.minLength(4)]),
    confirm: new UntypedFormControl('', [Validators.required, Validators.pattern('^[0-9]+$'), Validators.minLength(4)])
  });

  constructor(
    private router: Router,
    private fb: UntypedFormBuilder,
    private store: Store,
    private sharedService: SharedService
  ) {
    this.subdomain = this.sharedService.getSubDomain();
    this.getUserData$ = this.store.select(forgotPasscodeSelector.getForgotPasscodeUserNeedsHelpRequest);
  }

  submitNewUserPasscode() {
    if (this.passwordForm.value.passcode === this.passwordForm.value.confirm) {
      const req: INewUserPasscodeRequest = {
        passcode: this.passwordForm.value.passcode
      };

      this.store.dispatch(newUserPasscode.loadNewUserPasscodes({ request: req }));
    }
  }
}
